import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Globals } from '../../app.globals';
import { Observable } from 'rxjs/Rx';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UserService, PlaylistService, SongsService, AlbumsService, ArtistService } from '../../api';

@Component({
  selector: 'app-generic-avatar-gridview',
  templateUrl: './generic-avatar-gridview.component.html',
  styleUrls: ['./generic-avatar-gridview.component.css']
})
export class GenericAvatarGridviewComponent implements OnInit {
  @Input() item: any;
  @Input() bigAvatar: boolean = false;  // default size
  @Input() artistDtail: boolean = false;  // default size
  @Input() refresh: boolean = false;
  @Input() link: boolean = true;
  private image: any;
  private routeSubscriber = null;

  constructor(private playlistService: PlaylistService, private route: ActivatedRoute, private router: Router,
    private songService: SongsService, private albumService: AlbumsService, private artistService: ArtistService, private userService: UserService) { }

  ngOnInit() {
    this.processImage();
    if (this.refresh) {
      this.routeSubscriber = this.route.params.subscribe((params: any) => {
        if (params.songSlug) {
          this.songService.getSongDetailBySlug(params.songSlug).subscribe((res) => {
            this.item = res;
            this.processImage();
          });
        } else if (params.albumSlug) {
          console.log("album view");
          this.albumService.getAlbumDetailsBySlug(params.albumSlug).subscribe((res) => {
            this.item = res;
            this.processImage();
          });
        } else if (params.artistSlug) {
          // to check if artist's data exist or not
          if(this.item == null || (typeof this.item) == 'undefined') {
            this.artistService.getArtistDetailsBySlug(params.artistSlug)
              .subscribe((res) => {
                this.item = res;
                this.processImage();
              });
          } else {
            this.processImage();
          }
        } else if (params.id) {
          this.playlistService.getPlaylistDetail(params.id)
            .subscribe((res) => {
              this.item = res;
              this.processImage();
            });
        } else if (params.screenname) {
          this.userService.getUserDetailsBySlug(params.screenname)
            .subscribe((res) => {
              this.item = res;
              this.processImage();
            });
        }
      });
    }
  }

  processImage() {
    let itemType = (typeof this.item !== 'undefined' && typeof this.item._type !== 'undefined') ? this.item._type : 'playlist';
    switch (itemType) {
      case 'album':
        if (!this.item.image || this.item.image.indexOf('mspro-photos') <= 0) {
          this.image = new Globals().domain;
          this.image += (this.item && this.item.image !== '' && this.item.image != null) ?
            this.item.image : '/images/artist_default_avatar.jpg';
        } else {
          this.image = this.item.image;
        }
        break;
      case 'playlist':
        this.image = this.item.playlist_image;
        break;
      case 'song':
        this.image = (this.item.album != null && this.item.album.image != null && this.item.album.image.trim() !== '')
          ? this.item.album.image : (this.item.artist != null && this.item.artist.image != null &&
            this.item.artist.image.trim() !== '' && this.item.artist.image != null ?
            this.item.artist.image : new Globals().domain + '/images/artist_default_avatar.jpg');
        break;
      case 'artist':
        this.image = (this.item.image && this.item.image !== '') ? this.item.image :
          new Globals().domain + '/images/artist_default_avatar.jpg';
        break;
      case 'account':
        this.image = this.item.avatar;
        break;
    }
  }

  routeToAvatarSource(event) {
    event.stopPropagation();
    event.preventDefault();
    if(this.link) {
        let itemType = (typeof this.item !== 'undefined' && typeof this.item._type !== 'undefined') ? this.item._type : 'playlist';
        switch (itemType) {
            case 'song':
                if (this.item.album && this.item.album.slug) {
                    this.router.navigate(['/collection', this.item.album.slug]);
                } else {
                    this.router.navigate(['/song', this.item.slug]);
                }
                break;
            case 'artist':
                this.router.navigate(['/artist', this.item.slug]);
                break;
            case 'album':
                this.router.navigate(['/collection', this.item.slug]);
                break;
            case 'playlist':
                this.router.navigate(['/playlist', this.item.slug]);
                break;
            case 'account':
                this.router.navigate(['/account', this.item.slug]);
                break;
        }
    }

  }

  ngOnDestroy() {
    if (this.routeSubscriber != null) {
      this.routeSubscriber.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/generic-avatar-gridview/generic-avatar-gridview.component.ts